module.exports = __webpack_public_path__ + "static/html-element-advanced_5-799ebd76423681d1432b85cd231d47df.jpg";